module.exports = __webpack_public_path__ + "img/varios-origamis-dentro-de-recipiente.jpg";